<header class="navbar">
  <div class="navbar__container">
    <nav class="navbar__nav">
      <a routerLink="/" fragment="how-it-works" class="navbar__link">{{ 'navbar.howItWorks' | translate }}</a>
      <a routerLink="/" fragment="features" class="navbar__link">{{ 'navbar.features' | translate }}</a>
      <a routerLink="/" fragment="pricing" class="navbar__link">{{ 'navbar.pricing' | translate }}</a>
    </nav>

    <a routerLink="/" class="navbar__brand" aria-label="HireFit home">
      <img src="/svg-assets/Logo%201%20SVG.svg" alt="HireFit" class="navbar__logo" />
    </a>

    <div class="navbar__actions">
      <div class="navbar__locale-switcher" role="group" [attr.aria-label]="'common.languageSelector' | translate">
        <button
          type="button"
          class="navbar__locale-btn"
          [class.navbar__locale-btn--active]="locale() === 'es'"
          (click)="setLocale('es')"
        >
          ES
        </button>
        <button
          type="button"
          class="navbar__locale-btn"
          [class.navbar__locale-btn--active]="locale() === 'en'"
          (click)="setLocale('en')"
        >
          EN
        </button>
      </div>

      @if (auth()) {
        <a routerLink="/dashboard" class="navbar__link navbar__link--active-check" routerLinkActive="navbar__link--active">
          {{ 'navbar.dashboard' | translate }}
        </a>
        <div class="navbar__account">
          <span class="navbar__account-name">{{ userDisplayName() }}</span>
          <span class="navbar__account-icon" [attr.aria-label]="'navbar.myAccount' | translate">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2" />
              <path d="M4 20a8 8 0 0 1 16 0" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </span>
          <button type="button" class="navbar__logout-btn" (click)="logout()">{{ 'navbar.logout' | translate }}</button>
        </div>
      } @else {
        <a routerLink="/login" class="navbar__cta">
          <span>{{ 'navbar.login' | translate }}</span>
          <span class="navbar__cta-icon" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="5" y="11" width="14" height="10" rx="2" stroke="#4f46e5" stroke-width="2.2" />
              <path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="#4f46e5" stroke-width="2.2" stroke-linecap="round" />
            </svg>
          </span>
        </a>
      }
    </div>

    <button
      class="navbar__mobile-toggle"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="isMobileMenuOpen()"
      [attr.aria-label]="'navbar.toggleMenu' | translate"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        @if (isMobileMenuOpen()) {
          <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        } @else {
          <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        }
      </svg>
    </button>
  </div>

  @if (isMobileMenuOpen()) {
    <div class="navbar__mobile-menu">
      <a routerLink="/" fragment="how-it-works" class="navbar__mobile-link" (click)="closeMobileMenu()">{{ 'navbar.howItWorks' | translate }}</a>
      <a routerLink="/" fragment="features" class="navbar__mobile-link" (click)="closeMobileMenu()">{{ 'navbar.features' | translate }}</a>
      <a routerLink="/" fragment="pricing" class="navbar__mobile-link" (click)="closeMobileMenu()">{{ 'navbar.pricing' | translate }}</a>

      <div class="navbar__mobile-locale-switcher" role="group" [attr.aria-label]="'common.languageSelector' | translate">
        <button
          type="button"
          class="navbar__locale-btn"
          [class.navbar__locale-btn--active]="locale() === 'es'"
          (click)="setLocale('es')"
        >
          ES
        </button>
        <button
          type="button"
          class="navbar__locale-btn"
          [class.navbar__locale-btn--active]="locale() === 'en'"
          (click)="setLocale('en')"
        >
          EN
        </button>
      </div>

      <hr class="navbar__mobile-divider" />
      @if (auth()) {
        <a routerLink="/dashboard" class="navbar__mobile-link" (click)="closeMobileMenu()">{{ 'navbar.dashboard' | translate }}</a>
        <p class="navbar__mobile-user">{{ userDisplayName() }}</p>
        <button type="button" class="navbar__mobile-logout" (click)="logout()">{{ 'navbar.logout' | translate }}</button>
      } @else {
        <a routerLink="/login" class="navbar__mobile-cta" (click)="closeMobileMenu()">{{ 'navbar.login' | translate }}</a>
        <a routerLink="/register" class="navbar__mobile-link" (click)="closeMobileMenu()">{{ 'navbar.createAccount' | translate }}</a>
      }
    </div>
  }
</header>
